import Dashboard from '../index';
import Type1 from '../Type1';
// import Type2 from "../Type2";
import Type3 from '../Type3';
import Type4 from '../Type4';
import Type5 from '../Type5';
import Type6 from '../Type6';
import Type7 from '../Type7';
import Type8 from '../Type8';
import Type9 from '../Type9';
// import Type9a from "../Type9a";
import Type10 from '../Type10';
import Type11 from '../Type11';
import Type12 from '../Type12';
import Type13 from '../Type13';
import Type14 from '../Type14';
import Type15 from '../Type15';
import Type16 from '../Type16';
import Type18 from '../Type18';
import Type19 from '../Type19';
import Type20 from '../Type20';
import Type23 from '../Type23';
import Type22 from '../Type22';
import Type24 from '../Type24';
import Type25 from '../Type25';
import Type27 from '../Type27';
import Type28 from '../Type28';
// import Type29 from "../Type29";
// import Type30 from "../Type30";
// // import Type31 from "../Type31";
// import Type32 from "../Type32";
// import Type33 from "../Type33";
// import Type34 from "../Type34";
// import Type35 from "../Type35";
// import Type36 from "../Type36";
// import Type37 from "../Type37";
// import Type38 from "../Type38";
// import Type39 from "../Type39";
// import Type40 from "../Type40";
// import Type41 from "../Type41";
const routes = [
  {
    path: '/olympic/admin/classes/8/types/type1',
    name: 'Type 1',
    miniName: 'Type',
    component: Type1,
    layout: '/lms',

    exact: true,
  },
  // {
  //   path: "/type2",
  //   name: "Type 2",
  //   miniName: "B",
  //   component: Type2,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },

  {
    path: '/olympic/admin/classes/8/types/type3',
    name: 'Type 3',

    component: Type3,
    layout: '/lms',

    exact: true,
  },

  {
    path: '/olympic/admin/classes/8/types/type4',
    name: 'Type 4',

    component: Type4,
    layout: '/lms',

    exact: true,
  },

  {
    path: '/olympic/admin/classes/8/types/type5',
    name: 'Type 5',

    component: Type5,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type6',
    name: 'Type 6',

    component: Type6,
    layout: '/lms',

    exact: true,
  },

  {
    path: '/olympic/admin/classes/8/types/type7',
    name: 'Type 7',

    component: Type7,
    layout: '/lms',

    exact: true,
  },

  {
    path: '/olympic/admin/classes/8/types/type8',
    name: 'Type 8',

    component: Type8,
    layout: '/lms',

    exact: true,
  },

  {
    path: '/olympic/admin/classes/8/types/type9',
    name: 'Type 9',

    component: Type9,
    layout: '/lms',

    exact: true,
  },

  // {
  //   path: "/type9a",
  //   name: "Type 9a",
  //   miniName: "B",
  //   component: Type9a,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },

  {
    path: '/olympic/admin/classes/8/types/type10',
    name: 'Type 10',

    component: Type10,
    layout: '/lms',

    exact: true,
  },

  {
    path: '/olympic/admin/classes/8/types/type11',
    name: 'Type 11',

    component: Type11,
    layout: '/lms',

    exact: true,
  },

  {
    path: '/olympic/admin/classes/8/types/type12',
    name: 'Type 12',

    component: Type12,
    layout: '/lms',

    exact: true,
  },

  {
    path: '/olympic/admin/classes/8/types/type13',
    name: 'Type 13',

    component: Type13,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type14',
    name: 'Type 14',

    component: Type14,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type15',
    name: 'Type 15',

    component: Type15,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type16',
    name: 'Type 16',

    component: Type16,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type18',
    name: 'Type 18',

    component: Type18,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type19',
    name: 'Type 19',

    component: Type19,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type20',
    name: 'Type 20',

    component: Type20,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type22',
    name: 'Type 22',

    component: Type22,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type23',
    name: 'Type 23',

    component: Type23,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type24',
    name: 'Type 24',

    component: Type24,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type25',
    name: 'Type 25',

    component: Type25,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type27',
    name: 'Type 27',

    component: Type27,
    layout: '/lms',

    exact: true,
  },
  {
    path: '/olympic/admin/classes/8/types/type28',
    name: 'Type 28',

    component: Type28,
    layout: '/lms',

    exact: true,
  },

  // {
  //   path: "/type29",
  //   name: "Type 29",
  //   miniName: "B",
  //   component: Type29,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },

  // {
  //   path: "/type30",
  //   name: "Type 30",
  //   miniName: "B",
  //   component: Type30,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },

  // {
  //   path: "/type31",
  //   name: "Type 31",
  //   miniName: "B",
  //   component: Type31,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },

  // {
  //   path: "/Type32",
  //   name: "Type 32",
  //   miniName: "B",
  //   component: Type32,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },

  // {
  //   path: "/Type33",
  //   name: "Type 33",
  //   miniName: "B",
  //   component: Type33,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },
  // {
  //   path: "/Type34",
  //   name: "Type 34",
  //   miniName: "B",
  //   component: Type34,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },
  // {
  //   path: "/Type35",
  //   name: "Type 35",
  //   miniName: "B",
  //   component: Type35,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },
  // {
  //   path: "/Type36",
  //   name: "Type 36",
  //   miniName: "B",
  //   component: Type36,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },
  // {
  //   path: "/Type37",
  //   name: "Type 37",
  //   miniName: "B",
  //   component: Type37,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },
  // {
  //   path: "/Type38",
  //   name: "Type 38",
  //   miniName: "B",
  //   component: Type38,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },
  // {
  //   path: "/Type39",
  //   name: "Type 39",
  //   miniName: "B",
  //   component: Type39,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // }
  // ,
  // {
  //   path: "/Type40",
  //   name: "Type 40",
  //   miniName: "B",
  //   component: Type40,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // }, {
  //   path: "/Type41",
  //   name: "Type 41",
  //   miniName: "B",
  //   component: Type41,
  //   layout: "/lms",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // }
];

export default routes;
